import { object, string, boolean, mixed, number } from 'yup';
import { TFunction } from 'i18next';

import { SelectedInvestmentCategoryOption } from '../../models/Forms';

export enum MoventumPortfolios {
  Balanced = 'balanced',
  Defensive = 'defensive',
  Dynamic = 'dynamic',
  Offensive = 'offensive',
}

export function makeBoTAccountCreationSchema(t: TFunction) {
  return object().shape({
    accountName: string().required(t('form.required')),
    useCustomer1Address: boolean().required(t('form.required')),
    address: object()
      .shape({
        firstName: string(),
        lastName: string(),
        street: string(),
        streetNumber: string(),
        city: string(),
        psc: string(),
        state: string(),
      })
      .when('useCustomer1Address', {
        is: false,
        then: (schema) =>
          schema
            .shape({
              firstName: string().required(t('form.required')),
              lastName: string().required(t('form.required')),
              street: string().required(t('form.required')),
              streetNumber: string().required(t('form.required')),
              city: string().required(t('form.required')),
              psc: string().required(t('form.required')),
              state: string().required(t('form.required')),
            })
            .required(t('form.required')),
      }),
    bankAccount: object()
      .shape({
        accountOwnerName: string().required(t('form.required')),
        IBAN: string().required(t('form.required')),
        Swift: string().required(t('form.required')),
        bankName: string().required(t('form.required')),
        state: string().required(t('form.required')),
      })
      .required('form.required'),
    selectedInvestmentCategory: mixed()
      .oneOf(Object.values(SelectedInvestmentCategoryOption))
      .required(t('form.required')),
    experienceInSelectedCategory: string().required(t('form.required')),
    avgNumberOfYearlyTransactions: number(),
    avgValueOfYearlyTransactions: number(),
    chosenPortfolio: string().oneOf(Object.values(MoventumPortfolios)).required(t('form.required')),
    plannedInvestmentDeposit: number().nullable(),
    plannedInvestmentDepositCurrency: string(),
    plannedWithdrawal: number().nullable(),
    plannedWithdrawalCurrency: string(),
    transferingFromFranklinTempleton: boolean(),
    franklinTempletonDepositNumber: string().when('transferingFromFranklinTempleton', {
      is: true,
      then: (schema) => schema.required(t('form.required')),
    }),
  });
}
